module.exports = __webpack_public_path__ + "img/ic_thumb.8da143ed.svg";